<template>
  <div class="admin-header">
    <div class="logo">
      <img
        class="logo-img"
        v-if="titles == '样衣星球'"
        :src="imgur"
        alt="示例图片"
      />
      <img class="logo-img" v-else :src="imgurs" alt="示例图片" />
    </div>
    <div class="options">
      <span>
        <span :style="{ marginRight: '36px', color: '#999' }"
          >运营人员:{{ $store.getters.userInfo?.nickname ?? "未登录" }}</span
        >
      </span>
      <!-- 自定义退出确认弹窗 -->
      <div class="exit-wrapper" @click.stop>
        <!-- 触发按钮 -->
        <span class="link exit-btn" @click="showConfirm = true">退出</span>

        <!-- 确认弹窗（v-if 控制销毁/重建，避免内存泄漏） -->
        <div class="confirm-modal" v-if="showConfirm">
          <div class="confirm-content">
            <div class="confirm-title">确认退出吗？</div>
            <div class="confirm-btns">
              <button class="cancel-btn" @click="showConfirm = false">
                取消
              </button>
              <button class="confirm-btn" @click="handleExit">确认</button>
            </div>
          </div>
          <!-- 蒙层 -->
          <div class="modal-mask" @click="showConfirm = false"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from "/src/layouts/admin/123.png";
import urls from "/src/layouts/admin/456.png";
export default {
  data() {
    return {
      titles: "",
      imgur: url,
      imgurs: urls,
      // 控制确认弹窗显示/隐藏
      showConfirm: false,
    };
  },

  mounted() {
    this.titles = process.env.VUE_APP_TITLE || "默认标题";
  },
  methods: {
    // 处理退出逻辑
    async handleExit() {
      // 先隐藏弹窗
      this.showConfirm = false;
      try {
        await this.$store.dispatch("logout");
        // 自定义提示（替代 el-message，若没有则用 alert 兜底）
        this.showMessage("退出登录成功", "success");
        // 延迟跳转，避免组件卸载冲突
        setTimeout(() => {
          this.$router.push("/yy2126/login");
        }, 100);
      } catch (error) {
        this.showMessage("退出登录失败，请重试", "error");
      }
    },
    // 自定义消息提示（兼容有无 Element 的场景）
    showMessage(text, type = "info") {
      if (this.$message) {
        this.$message[type](text);
      } else {
        // 无 Element 时用原生提示兜底
        alert(`${type === "success" ? "✅" : "❌"} ${text}`);
      }
    },
  },
  // 组件卸载时清空定时器/状态，避免内存泄漏
  beforeUnmount() {
    this.showConfirm = false;
  },
};
</script>

<style lang="scss" scoped>
@import "./AdminHeader.scss";

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 82px;
  border-bottom: 1px solid #eee;

  .logo {
    .aaa {
      color: red;
    }
  }

  .options {
    display: flex;
    align-items: center;

    .exit-wrapper {
      position: relative;

      .exit-btn {
        cursor: pointer;
        color: #409eff;

        &:hover {
          color: #66b1ff;
        }
      }

      // 确认弹窗样式
      .confirm-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;

        .modal-mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
        }

        .confirm-content {
          width: 300px;
          background: #fff;
          border-radius: 4px;
          padding: 20px;
          position: relative;
          z-index: 1;

          .confirm-title {
            font-size: 16px;
            margin-bottom: 20px;
            text-align: center;
            color: #333;
          }

          .confirm-btns {
            display: flex;
            justify-content: center;
            gap: 20px;

            button {
              padding: 8px 20px;
              border: none;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;

              &:hover {
                opacity: 0.9;
              }
            }

            .cancel-btn {
              background: #e6e6e6;
              color: #666;
            }

            .confirm-btn {
              background: #409eff;
              color: #fff;
            }
          }
        }
      }
    }
  }

  &.theme-deer {
    background-color: #683d81;
    .logo,
    .options {
      color: white;
    }
  }

  &.theme-default {
    background-color: #ffae00;
  }
}
.logo-img {
  width: 100%;
  max-width: 148px;
  height: auto;
  display: block;
  margin-left: 0 !important;
  padding-left: 0 !important;
  box-sizing: border-box;
}
</style>